import { render, staticRenderFns } from "./APIdetail.vue?vue&type=template&id=15aafad5&scoped=true"
import script from "./APIdetail.vue?vue&type=script&lang=js"
export * from "./APIdetail.vue?vue&type=script&lang=js"
import style0 from "./APIdetail.vue?vue&type=style&index=0&id=15aafad5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aafad5",
  null
  
)

export default component.exports